// h-12 = 3rem = 48px + 10px buffer, so the banner starts sliding away just before the cursor reaches it
export const BANNER_HEIGHT = 58
